import { Component, ViewEncapsulation } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Template } from '../_types/template';
import { TemplatesService } from '../_services/templates.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Editor } from 'tinymce';
import { LoginService } from '../../login/login.service';
import { DialogService } from 'primeng/dynamicdialog';
import { FilesService } from '../../common/_services/files.service';
import { File } from 'src/app/modules/common/_types/file';
import { CompaniesService } from '../../companies/_services/companies.service';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { ContractsService } from '../../companies/_services/contracts.service';
import { TemplatesContractsService } from '../_services/templates-contracts.service';
import { TemplateContracts } from '../_types/template-contract';
import { TemplateCompanyComponent } from './template-company/template-company.component';
import { TemplatesVariablesComponent } from './templates-variables/templates-variables.component';
import { FormControl } from '@angular/forms';
import { TwilioService } from '../_services/twilio.service';


@Component({
    selector: 'app-templates-detail',
    templateUrl: './templates-detail.component.html',
    styleUrls: ['./templates-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TemplatesDetailComponent {
  public templateFormGroup!: RxFormGroup;

  public template: Template = new Template();
  public templateTypes: any = [];
  public documentTypes: any = [];
  public totalCompaniesRecords: number = 0;
  public typeOfDocuments: any = [{value: 'file', label: 'Fichero'}, {value: 'html', label: 'HTML'}];
  public templateDestinationTypes: any = [{value: 'all', label: 'Todos'}, {value: 'Case', label: 'Expediente'}, {value: 'Worker', label: 'Operario'}];
  public twilioContentVariables:any[] = [];

  init: EditorComponent['init'] = {
    promotion: false,
    content_css: '/assets/tinymce/content.css',
    plugins: 'lists link image table code variables',
    custom_elements: 'variable',
    extended_valid_elements: 'span[variable]',
    toolbar: 'undo redo | formatselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | link image table | code | variables-menu',
    external_plugins: {
      variables: '/assets/tinymce/variables-plugin.js'
    },
    variable_mapper: {
      Code: 'Código',
      Date: 'Fecha',
      TaxAmount: 'IVA',
      Subtotal: 'Subtotal',
      Total: 'Total'
    },
    setup: (ed:Editor) => {
      ed.on('variableClick', (e:any) => {
         console.log('click', e);
      });
    },
  };


  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public files: any[] = [];
  public companies: any;
  public ingredient!: string;

  constructor(
    private templatesService: TemplatesService,
    private twilioService: TwilioService,
    private topbarService: TopbarService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
    private dialogService: DialogService,
    private filesService: FilesService,
    private templatesContractsService: TemplatesContractsService
  ) {

    this.templateFormGroup = this.formBuilder.formGroup<Template>(this.template) as RxFormGroup;
    this.templateFormGroup.addControl("typeOfDocument", new FormControl("file"));
    this.templateFormGroup.addControl("templateDestinationType", new FormControl("all"));
    this.templateTypes = this.templatesService.templateTypes();
  }

  async ngOnInit() {

    this.topbarService.setTitle("Detalles de plantilla");
    this.topbarService.addBreadcrumb("Plantillas", "/templates");
    let id = this.route.snapshot.params['guid'];
    if (id != null && id != '0') {
      await this.loadTemplate(id);
    }
    this.getDocumentTypes();
    this.allowWrite = this.loginService.hasPermission("TEMPLATES.WRITE");
    this.allowDelete = this.loginService.hasPermission("TEMPLATES.DELETE");
  }

  async loadTemplate(id: string) {
    this.template = await firstValueFrom(this.templatesService.get(id, {include: ['file']}));
    this.templateFormGroup.patchValue(this.template);
    if(this.template.templateType == "Document"){
      this.templateFormGroup.addControl("typeOfDocument", new FormControl("file"));
      this.templateFormGroup.patchValue({typeOfDocument: (this.template.fileId != null && this.template.fileId != "") ? "file" : "html"});

    }else if(this.template.templateType == "Whatsapp" && this.template.contentSID){
      this.getContentSID(this.template.contentSID);
    }
    if(this.template.templateDestinationType == null || this.template.templateDestinationType == ""){
      this.templateFormGroup.addControl("templateDestinationType", new FormControl("all"));
      this.templateFormGroup.patchValue({templateDestinationType: "all"});
    }

    this.loadCompanies();
  }

  onContentSidChange(){
    let newContentSid = this.templateFormGroup.get('contentSid')?.value;
    if(newContentSid) this.getContentSID(newContentSid);
  }

  async getDocumentTypes(){
    this.documentTypes = this.templatesService.getDocumentTypes();
  }

  getContentSID(contentSid: string) {
    if(!this.template.templateConfig) this.template.templateConfig = {};
    this.twilioService.getContentSid(contentSid).subscribe({
      next: (data: any) => {
        this.templateFormGroup.get('content')?.setValue(data.body);
        this.template.content = data.body;
        Object.keys(data.variables).forEach((key) => {
          let field = this.template.templateConfig.fields.find((field: any) => field.name === key);
          if(field==null){
            this.template.templateConfig.fields.push({name: key, type: "variable", value: ""});
          }
        });
      }
    });
  }

  getConfigurationKeys():string[]{
    let keys:string[] = [];
    if(this.template?.templateConfig) keys = Object.keys(this.template.templateConfig);
    return keys;
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.templateFormGroup);
    if (valid) {

      let config:any = this.template.templateConfig;

      this.template = Object.assign(this.template, this.templateFormGroup.value);
      this.template.templateConfig = config;
      if(this.template.templateDestinationType == "all"){
        this.template.templateDestinationType = null;
      }
      let templateItem = await firstValueFrom(this.templatesService.save(this.template));

      if (this.files.length > 0) {
        try {
          for (let file of this.files) {
            let data: File = new File();
            data.fileName = file.name;
            data.size = file.size;
            data.contentType = file.type;
            //data.path = file.name;

            //creamos el file
            let fileResponse = await firstValueFrom(this.filesService.save(data));

            //subimos el fichero al file
            let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, file));

            //guardamos el file en el expediente
            templateItem.fileId = fileResponse.id as string;
            await firstValueFrom(this.templatesService.save(templateItem));
      
            this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Plantilla guardada correctamente." });
            this.router.navigate(['templates']);

          }
        } catch (error) {
          this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al guardar el fichero." });
        }
      }else{
        this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Plantilla guardada correctamente." });
        this.router.navigate(['templates']);
      }

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }


  async loadCompanies() {
    let filters = {
      templateId: new Filter(FilterOperation.equals, 'templateId', "", this.template.id)
    };

    let params: IParamsCollection = {
      include: ['company', 'contract']
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.templatesContractsService.all(params));
    this.companies = response.data;
    this.totalCompaniesRecords= response.meta["total"];
  }

  addCompany(templateCompany: any, all:boolean) {
    const ref = this.dialogService.open(TemplateCompanyComponent, {
      closable: true,
      modal: true,
      data: {
        templateCompanyId: templateCompany.id,
        companyId: (all ? templateCompany.companyId:null),
        templateId: this.template.id
      },
      header: "Asignar compañía aseguradora",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
      setTimeout(() => {
        this.loadCompanies();
      }, 500);
    });
  }
  
  async deleteCompany(templateCompany: any) {
    var message = "¿Está seguro que desea desasignar el contrato  de la compañía aseguradora ?";
    this.confirmationService.confirm({
      message: message,
      header: "Desasignar contrato/s de companía aseguradora",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.templatesContractsService.delete(templateCompany.id).subscribe({
          next: (data: any) => {
            this.loadCompanies();
            this.messageService.add({ closable: true, severity: 'success', detail: "Contrato desasignada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });

  }
  
    
  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la plantilla?",
      header: "Eliminar plantilla",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.templatesService.delete(this.template.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Plantilla eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  cancel() {
    this.router.navigate(['templates']);
  }

  async onFileSelect(event: any) {
    let files = event.files;
    for (let file of files) {
      this.files.push(file);
    }
    if(this.template.file != null) this.template.file.fileName = "";
  }
  
  downloadFile(fileId?: string) {
    if(fileId != null && fileId!=""){
      this.filesService.download(fileId);
    }
  }

  help(){

    const ref = this.dialogService.open(TemplatesVariablesComponent, {
      closable: true,
      modal: true,
      data: {
        templateType: this.template.templateType
      },
      header: "Variables disponibles",
      width: '40%'
    });
    ref.onClose.subscribe((data: any) => {
    });
    
    }

}
